import {
    shipToUrl,
    supplyCenterUrl,
    categoryListUrl,
    productListUrl,
    addCartUrl,
    batchAddShoppingCartUrl,
    queryCartUrl,
    queryChangeShipUrl,
    cmgtInventoryUrl,
    deleteCartUrl,
    updateShipToUrl,
    promosPriceUrl,
    cartCountUrl,
    // defaultShipToAndSCUrl,
    getProxySupplyCenterUrl,
    orderPreview,
    orderAdd,
    stContactQuery,
    queryTMSKUUrl,
    demoProductUrl,
    cartQuantityUrl,
    queryQuoteUrl,
    queryCustomerQuoteUrl,
    searchHistoryUrl,
    operationLogUrl,
    sQouteUrl,
    getUploadFileLimitUrl,
    saveAssayIdUrl,
    range_CRD_Url,
} from 'Utils/urlUtil';
import util from 'Utils/commonUtil';
import {get, post, callApi} from 'Utils/apiUtil';
import {setDefaultSCData, setSCData, setShipToData} from 'Actions/localData';

export const SHIP_TO = 'SHIP_TO';
export const SUPPLY_CENTER = 'SUPPLY_CENTER';
export const CATEGORY_LIST = 'CATEGORY_LIST';
export const CATEGROY_SELECTED = 'CATEGROY_SELECTED';
export const PRODUCT_LIST = 'PRODUCT_LIST';
export const ADD_CART = 'ADD_CART';
export const QUERY_CART = 'QUERY_CART';
export const QUERY_CHANGE_SHIP = 'QUERY_CHANGE_SHIP';
export const QUERY_EONE_INVENTORY = 'QUERY_EONE_INVENTORY';
export const DELETE_CART = 'DELETE_CART';
export const CART_PRICE = 'CART_PRICE';
export const DEFAULT_SHIPTO_SC = 'DEFAULT_SHIPTO_SC';
export const UPDATE_SHIP_TO = 'UPDATE_SHIP_TO';
export const PRODUCT_SEARCH_FIELD = 'PRODUCT_SEARCH_FIELD';
export const PRODUCT_MORE_INITIAL = 'PRODUCT_MORE_INITIAL';
export const PRODUCT_MORE_SUCCESS = 'PRODUCT_MORE_SUCCESS';
export const PRODUCT_MORE_FAILURE = 'PRODUCT_MORE_FAILURE';
export const PREVIEW_ORDER = 'PREVIEW_ORDER';
export const UPDATE_PREVIEW_ORDER = 'UPDATE_PREVIEW_ORDER';
export const RANGE_CRD = 'RANGE_CRD';
export const ADD_ORDER = 'ADD_ORDER';
export const ST_CONTACT_QUERY = 'ST_CONTACT_QUERY';
export const TM_PRODUCT = 'TM_PRODUCT';
export const ORDER_QUANTITY = 'ORDER_QUANTITY';
export const SET_OTHER_SHIPTO_NUMBER = 'SET_OTHER_SHIPTO_NUMBER';
export const QUERY_QUOTE = 'QUERY_QUOTE';
export const QUERY_CUSTOMER_QUOTE = 'QUERY_CUSTOMER_QUOTE';
export const SEARCH_HISTORY = 'SEARCH_HISTORY';
export const HOT_TERM = 'HOT_TERM';
export const UPDATE_PRODUCTS_LIST = 'UPDATE_PRODUCTS_LIST';

export const S_PRICE = 'S_PRICE';
export const TM_PRODUCT_SEARCH = 'TM_PRODUCT_SEARCH';
export const SWITCH_CHOOSE_PRICE = 'SWITCH_CHOOSE_PRICE';
export const FROM_PRODUCT_SEARCH_FIELD = 'FROM_PRODUCT_SEARCH_FIELD';
export const FROM_SHOPPING_CART = 'FROM_SHOPPING_CART';
export const UPDATE_OFFLINE_ORDER_CREDENTIAL =
    'UPDATE_OFFLINE_ORDER_CREDENTIAL';
export const UPLOAD_FILE_LIMIT = 'UPLOAD_FILE_LIMIT';
export const CHECKED_ASSAYID = 'CHECKED_ASSAYID';

const abyss = (data, length) => {
    let showAbyss = false;
    if (util.isArray(data) && data.length < length) {
        showAbyss = true;
    }
    return showAbyss;
};

export const getShipToInfo = (email, func) => {
    return (dispatch) =>
        dispatch(get(shipToUrl, {email})).then((res) => {
            dispatch({type: SHIP_TO, payload: res});
            func && func(res);
        });
};

export const getSupplyCenter = (id) => {
    return (dispatch) =>
        dispatch(get(supplyCenterUrl, {shipToNo: id})).then((res) =>
            dispatch({type: SUPPLY_CENTER, payload: res}),
        );
};

export const getCategoryList = () => {
    return (dispatch) =>
        dispatch(get(categoryListUrl)).then((res) =>
            dispatch({type: CATEGORY_LIST, payload: res}),
        );
};

// Update Categroy Selected
export const updateCategroySelected = (params) => ({
    type: CATEGROY_SELECTED,
    payload: params,
});

// Update Product Search Fields
export const updateProductSearchFields = (params) => ({
    type: PRODUCT_SEARCH_FIELD,
    payload: params,
});

export const updateFromProductSearch = (params) => ({
    type: FROM_PRODUCT_SEARCH_FIELD,
    payload: params,
});

export const updateFromShoppingCart = (params) => ({
    type: FROM_SHOPPING_CART,
    payload: params,
});

export const updateProducts = (params) => ({
    type: UPDATE_PRODUCTS_LIST,
    payload: params,
});

export function getProductList(params, func, isDemoSite) {
    const request = null;
    let url = isDemoSite ? demoProductUrl : productListUrl;

    let productPage = 1;

    const options = {
        data: {
            email: params.email,
            supplyCenterId: params.supplyCenterId,
            categoryId: params.categoryId,
            pageNum: productPage,
            pageSize: params.pageSize,
            skuQuery: params.skuQuery
                ? params.skuQuery.trim()
                : params.skuQuery,
            shipToNumber: params.shipToNumber,
            purchaseOrderMode: params.purchaseOrderMode,
        },
    };

    const success = (response) => {
        getCustomerQuote(
            response.data.map((item) => item.sku),
            false,
        );
        return {
            type: PRODUCT_LIST,
            payload: {productList: response, productListLoaded: true},
        };
    };
    const failure = null;

    return callApi(url, options, request, success, failure, func);
}

export function getMoreProducts(params, isDemoSite) {
    let url = isDemoSite ? demoProductUrl : productListUrl;

    return (dispatch, getState) => {
        const order = getState().order;

        const options = {
            data: {
                email: params.email,
                supplyCenterId: params.supplyCenterId,
                categoryId: params.categoryId,
                pageNum: params.pageNum,
                pageSize: params.pageSize,
                skuQuery: params.skuQuery,
                shipToNumber: params.shipToNumber,
                purchaseOrderMode: params.purchaseOrderMode,
            },
        };
        const request = () => ({
            type: PRODUCT_MORE_INITIAL,
            payload: {
                productListLoaded: false,
                productLoadingMore: true,
                productAbyss: false,
            },
        });
        const failure = () => ({
            type: PRODUCT_MORE_FAILURE,
            payload: {
                productListLoaded: true,
                productLoadingMore: false,
                productAbyss: true,
            },
        });
        const success = (response) => {
            const apiReponseData = response.data;
            const list =
                util.isArray(response.data) && order.productList.data
                    ? order.productList.data.concat(response.data)
                    : [];
            response.data = list;
            const skus = apiReponseData.map((item) => item.sku);
            dispatch(getCustomerQuote(skus, true));
            return {
                type: PRODUCT_MORE_SUCCESS,
                payload: {
                    productList: response,
                    productListLoaded: true,
                    productLoadingMore: false,
                    productAbyss: abyss(apiReponseData, order.pageSize),
                },
            };
        };

        return dispatch(callApi(url, options, request, success, failure));
    };
}

export const addCart = (params) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = (response) => ({type: ADD_CART, payload: {...response}});
    const failure = null;

    return callApi(addCartUrl, options, request, success, failure);
};

export const batchAddCart = (params) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = (response) => ({type: ADD_CART, payload: {...response}});
    const failure = null;

    return callApi(batchAddShoppingCartUrl, options, request, success, failure);
};

export const getShipToOfNotSC = (params) => {
    const request = null;

    let url = getProxySupplyCenterUrl + '?stNumber=' + params.shipToNum;

    const options = {
        method: 'GET',
    };

    const success = [
        (response) => ({type: DEFAULT_SHIPTO_SC, payload: {...response}}),
        // (response) => (setShipToData(response.data.shipTo)),
        // (response) => (setSCData(response.data.supplyCenter))
    ];
    const failure = null;

    return callApi(url, options, request, success, failure);
};

export const getDefaultShipToAndSC = (params, func) => {
    const request = null;

    let url = getProxySupplyCenterUrl + '?stNumber=' + params.shipToNum;

    const options = {
        method: 'GET',
    };

    let currentShipToNumber = params.shipToNum;
    const success = [
        (response) => ({type: DEFAULT_SHIPTO_SC, payload: {...response}}),
        (response) => () => {
            // response.data.shipTo['temporaryShipToNumber'] = currentShipToNumber;
            if (response.data && response.data.length > 0) {
                setShipToData(response.data[0]);
            }
        },
        (response) =>
            response.data &&
            response.data.length > 0 &&
            setDefaultSCData(response.data[0]),
    ];
    const failure = null;

    return callApi(url, options, request, success, failure, func);
};

export const queryCart = (params, func) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = (response) => ({type: QUERY_CART, payload: {...response}});
    const failure = null;

    return callApi(queryCartUrl, options, request, success, failure, func);
};

export const queryChangeShip = (params, func) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = (response) => ({
        type: QUERY_CHANGE_SHIP,
        payload: {...response},
    });
    const failure = null;

    return callApi(
        queryChangeShipUrl,
        options,
        request,
        success,
        failure,
        func,
    );
};

export const queryEoneInventory = (params, func) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = (response) => ({
        type: QUERY_EONE_INVENTORY,
        payload: {...response},
    });
    const failure = null;

    // return callApi(queryEoneInventoryUrl, options, request, success, failure, func)
    return callApi(cmgtInventoryUrl, options, request, success, failure, func);
};

export const deleteCart = (params, func) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = (response) => ({type: DELETE_CART, payload: {...response}});
    const failure = null;

    return callApi(deleteCartUrl, options, request, success, failure, func);
};

export const calculatePrice = (params, clearPriceFlg, switchChoosePrice) => {
    console.log(
        'switchChoosePrice================================',
        switchChoosePrice,
    );
    if (clearPriceFlg) {
        return (dispatch) => {
            dispatch({type: CART_PRICE, payload: {status: 'success'}});
        };
    } else {
        const request = null;

        const options = {
            data: params,
        };

        const success = (response) => ({
            type: CART_PRICE,
            payload: {...response},
        });

        let failure = null;
        if (
            typeof switchChoosePrice !== 'undefined' &&
            switchChoosePrice &&
            switchChoosePrice === 'switchPrice'
        ) {
            failure = (response) => ({
                type: CART_PRICE,
                payload: {...response},
            });
        }

        return callApi(promosPriceUrl, options, request, success, failure);
    }
};

export const getCartCount = (email) => {
    return (dispatch) =>
        dispatch(
            get(cartCountUrl, {
                email,
                purchaseOrderMode: util.getPurchaseOrderMode(),
            }),
        ).then((res) => {
            dispatch({type: ADD_CART, payload: res});
        });
};

export const updateShipTo = (params, func) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = [
        (response) => ({type: UPDATE_SHIP_TO, payload: response}),
        (response) => setShipToData(response.data.shipTo),
        (response) => setDefaultSCData(response.data.supplyCenter),
    ];
    const failure = null;

    return callApi(updateShipToUrl, options, request, success, failure, func);
};

export const previewOrder = (params) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = [(response) => ({type: PREVIEW_ORDER, payload: response})];
    const failure = null;

    return callApi(orderPreview, options, request, success, failure);
};

export const get_CRD_Range = (params) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = [(response) => ({type: RANGE_CRD, payload: response})];
    const failure = null;

    return callApi(range_CRD_Url, options, request, success, failure);
};

export const updatePreviewOrder = (params) => {
    return (dispatch) => {
        dispatch({
            type: UPDATE_PREVIEW_ORDER,
            payload: params,
        });
    };
};

export const addOrder = (params, func) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = [(response) => ({type: ADD_ORDER, payload: response})];
    const failure = null;

    return callApi(orderAdd, options, request, success, failure, func);
};

export const queryStContact = (params) => {
    const request = null;

    const options = {
        data: params,
    };

    const success = [
        (response) => ({type: ST_CONTACT_QUERY, payload: response}),
    ];
    const failure = null;

    return callApi(stContactQuery, options, request, success, failure);
};

export const queryTMSKUList = (queryKey, shipTo, func) => {
    return (dispatch) =>
        dispatch(get(queryTMSKUUrl, {queryKey: queryKey, shipTo})).then(
            (res) => {
                const data = Array.isArray(res.data) ? res.data : [];

                if (data.length > 0) {
                    dispatch(
                        getCustomerQuote(
                            data.map((item) => item.sku),
                            false,
                        ),
                    );
                }

                dispatch({type: TM_PRODUCT, payload: {...res, data}});
                func && func();
            },
        );
};

export function getTfsOfSkuInfor(queryKey, shipTo, func) {
    const url = `${queryTMSKUUrl}?shipTo=${shipTo}&queryKey=${queryKey}`;
    const options = {
        method: 'GET',
    };
    const request = () => ({
        type: TM_PRODUCT_SEARCH,
        payload: {cmgtOfSkuInfor: {}},
    });
    const success = (response) => {
        console.log('getTfsOfSkuInfor', response);
        // if (response.data && response.data.length > 0) {
        //     getCustomerQuote(response.data.map((item) => item.sku), false);
        // }
        func && func();
        return {type: TM_PRODUCT_SEARCH, payload: {noScOrderResult: response}};
    };
    const failure = () => ({
        type: TM_PRODUCT_SEARCH,
        payload: {noScOrderResult: {}},
    });

    return callApi(url, options, request, success, failure);
}

// Submit Shopping Cart Quantity
export function sumbitQuantity(params, func) {
    const request = null;
    const options = {data: params};
    const success = (response) => ({type: ORDER_QUANTITY, payload: response});
    const failure = null;

    return callApi(cartQuantityUrl, options, request, success, failure, func);
}

export const updateOtherShipToNumber = (otherShipToNumber) => {
    return (dispatch) => {
        dispatch({
            type: SET_OTHER_SHIPTO_NUMBER,
            payload: otherShipToNumber,
        });
    };
};

// query quote
export const getQuote = (sku, func) => {
    return (dispatch) =>
        dispatch(get(queryQuoteUrl, {sku})).then((res) => {
            dispatch({type: QUERY_QUOTE, payload: res});
            func && func(res);
        });
};

// query quote
export const getCustomerQuote = (skus, append, func) => {
    console.log('getCustomerQuote skus,append', skus, append);
    if (!skus || skus.length < 1) return;
    return (dispatch, getState) => {
        const {localData} = getState();
        const shipToNum = util.getShipToNumber(localData);
        const customerEmail = util.getPurchaseCustomerEmail();
        const stQuery = shipToNum
            ? `&customerStNumber=${encodeURIComponent(shipToNum)}`
            : '';

        return dispatch(
            get(
                `${queryCustomerQuoteUrl}${skus.join(
                    ',',
                )}&customerEmail=${customerEmail}${stQuery}`,
            ),
        ).then((res) => {
            if (res.data) {
                res.append = append;
            }
            dispatch({type: QUERY_CUSTOMER_QUOTE, payload: res});
            func && func(res);
        });
    };
};

// query search history
export const getSearchHistory = () => {
    return (dispatch) =>
        dispatch(get(searchHistoryUrl)).then((res) => {
            dispatch({type: SEARCH_HISTORY, payload: res});
        });
};

export const calculateSquotePrice = (params, clearPriceFlg) => {
    if (clearPriceFlg) {
        return (dispatch) => {
            dispatch({type: S_PRICE, payload: {status: 'success'}});
        };
    } else {
        const request = null;

        const options = {
            data: params,
        };

        const success = (response) => ({type: S_PRICE, payload: {...response}});
        const failure = null;

        return callApi(sQouteUrl, options, request, success, failure);
    }
};

export const operationLog = (params) => post(operationLogUrl, params);

// Update Product Search Fields
export const updateSwitchChoosePrice = (switchChoosePrice) => {
    return (dispatch) => {
        dispatch({
            type: SWITCH_CHOOSE_PRICE,
            payload: switchChoosePrice,
        });
    };
};

export const updateOfflineOrderCredential = (credentialParams) => {
    return (dispatch) => {
        dispatch({
            type: UPDATE_OFFLINE_ORDER_CREDENTIAL,
            payload: credentialParams,
        });
    };
};

export const getUploadFileLimit = (fileType) => {
    return (dispatch) =>
        dispatch(get(getUploadFileLimitUrl + '/' + fileType)).then((res) =>
            dispatch({type: UPLOAD_FILE_LIMIT, payload: res}),
        );
};

export const checkedAssayId = (data) => (dispatch) =>
    dispatch(post(saveAssayIdUrl, data)).then((res) => {
        dispatch({type: CHECKED_ASSAYID, payload: res});
        return res;
    });
